import type {ReactElement} from 'react';
import React from 'react';
import {SkeletonBrick} from '@Components/skeleton-brick';
import styles from './download-panel-skeletons.module.scss';

interface DownloadPanelSkeletonsProps {
  isPanelOpenedInModal?: boolean;
}

export function DownloadPanelSkeletons({isPanelOpenedInModal = false}: DownloadPanelSkeletonsProps): ReactElement {
  return (
    <ul className={`flex-v-row flex-align-items-center ${styles.gap}`}>
      {isPanelOpenedInModal ? (
        <li className="spacing-m-t-2 spacing-m-b-2">
          <SkeletonBrick width={200} height={24} />
        </li>
      ) : null}
      <li className={`flex-h-row flex-justify-between _full-width flex-items-center spacing-p-0 ${styles.listItem}`}>
        <SkeletonBrick width={67} height={22} />
        <SkeletonBrick width={138} height={22} />
      </li>
      <li className="flex-v-row _full-width">
        <SkeletonBrick className="spacing-m-b-2" width={67} height={22} />
        <div className="flex-h-row">
          <SkeletonBrick width={158} height={80} className="spacing-m-r-3" />
          <SkeletonBrick width={158} height={80} />
        </div>
      </li>
      <li className={`flex-h-row flex-justify-between _full-width flex-items-center spacing-p-0 ${styles.listItem}`}>
        <SkeletonBrick width={67} height={22} />
        <SkeletonBrick width={138} height={22} />
      </li>
      {isPanelOpenedInModal ? (
        <li className="spacing-m-t-4 spacing-m-b-4">
          <SkeletonBrick width={300} height={40} />
        </li>
      ) : null}
    </ul>
  );
}
